import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, List, ListItem, ListItemAvatar, Avatar, ListItemText, TextField, FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';

const SeatSelectModal = ({ open, onClose, participants, seat, onAssign, onUnassign }) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('all');
  const filtered = participants.filter(p => {
    const matchesName = search === '' || (p.name && p.name.toLowerCase().includes(search.toLowerCase()));
    const matchesStatus = status === 'all' || p.status === status;
    return matchesName && matchesStatus;
  });
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Koltuk Atama</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2, display: 'flex', gap: 1 }}>
          <TextField
            size="small"
            label="İsim Ara"
            value={search}
            onChange={e => setSearch(e.target.value)}
            fullWidth
          />
          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel>Durum</InputLabel>
            <Select
              value={status}
              label="Durum"
              onChange={e => setStatus(e.target.value)}
            >
              <MenuItem value="all">Tümü</MenuItem>
              <MenuItem value="invited">Davet Edilenler</MenuItem>
              <MenuItem value="confirmed">Katılacaklar</MenuItem>
              <MenuItem value="declined">Katılmayacaklar</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <List>
          {filtered.map(p => (
            <ListItem button key={p.id} onClick={() => onAssign && onAssign(p)}>
              <ListItemAvatar><Avatar>{p.name[0]}</Avatar></ListItemAvatar>
              <ListItemText primary={p.name} secondary={p.email} />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        {seat?.participant_id && (
          <Button color="error" onClick={() => onUnassign && onUnassign()}>
            Atamayı Kaldır
          </Button>
        )}
        <Button onClick={onClose}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
};
export default SeatSelectModal; 